import React from 'react';

const AddSubCounter = (props) => {
  return (
    <div className='add-sub-counter'>
      {props.count > props.minValue && (
        <button
          className={`add-sub-counter__btn add-sub-counter__btn--minus`}
          disabled={!(props.count > props.minValue)}
          onClick={() => props.decrement()}>
          -
        </button>
      )}
      <span className='add-sub-counter__number'>{props.count}</span>
      {props.count < props.maxValue && (
        <button
          className={`add-sub-counter__btn add-sub-counter__btn--plus`}
          disabled={!(props.count < props.maxValue)}
          onClick={() => props.increment()}>
          +
        </button>
      )}
    </div>
  );
};

export default AddSubCounter;
